import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route, Switch, useHistory, useLocation, useParams } from 'react-router-dom'
import { ROUTES } from '../utils/routes'
import { AppStore } from '../store/applicationState'
import { getStatusName } from '../utils/tendersUtils/tenderStatusHelper'
import { clearDataListener } from '../utils/tendersUtils/tenderDataHelper'
import { P404 } from '../pages'
import { GeneralActivity } from './StatisticContent/GeneralActivity'
import { FavoritesActivity } from './StatisticContent/FavoritesActivity'
import { ViewedItemsActivity } from './StatisticContent/ViewedItemsActivity'

export const StatisticContent = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()

  const { id, currentTenderId = +id } = useParams() as any
  const { tenders } = useSelector((store: AppStore) => store)

  const tendersForChoose = useMemo(
    () =>
      tenders.data?.filter((tender) =>
        ['active', 'toBeClosed', 'completed', 'catalog'].includes(getStatusName(tender))
      ),
    [tenders.data]
  )

  useEffect(() => {
    if (tendersForChoose?.length && !currentTenderId) {
      history.replace(`${ROUTES.adminPageStatistic}/${tendersForChoose[0].id}/general-activity`)
    }
  }, [tendersForChoose, currentTenderId])

  useEffect(() => {
    if (currentTenderId) clearDataListener(window.location.pathname, dispatch)
  }, [currentTenderId])

  return (
    <div className='w-full mt-4 px-2 pb-6 smallestpx-2'>
      <div className='flex flex-col md:flex-row justify-between'>
        <div className='tabs text-sm md:text-base mb-4 space-x-4 md:space-x-12 tabs-secondary overflow-x-auto'>
          <button
            type='button'
            className={`tab min-w-max ${
              location.pathname.search(`${ROUTES.adminPageStatistic}/${currentTenderId}/general-activity`) !== -1 &&
              'active'
            }`}
            onClick={() => history.push(`${ROUTES.adminPageStatistic}/${currentTenderId}/general-activity`)}
          >
            General activity
          </button>
          <button
            type='button'
            className={`tab min-w-max ${
              location.pathname.search(`${ROUTES.adminPageStatistic}/${currentTenderId}/favorites`) !== -1 && 'active'
            }`}
            onClick={() => history.push(`${ROUTES.adminPageStatistic}/${currentTenderId}/favorites`)}
          >
            Favorites
          </button>
          <button
            type='button'
            className={`tab min-w-max ${
              location.pathname.search(`${ROUTES.adminPageStatistic}/${currentTenderId}/viewed-items`) !== -1 &&
              'active'
            }`}
            onClick={() => history.push(`${ROUTES.adminPageStatistic}/${currentTenderId}/viewed-items`)}
          >
            Viewed items
          </button>
        </div>
      </div>
      {!!currentTenderId && (
        <Switch>
          <Route
            path={[
              `${ROUTES.adminPageStatistic}/:id/general-activity`,
              `/worthy${ROUTES.adminPageStatistic}/:id/general-activity`,
            ]}
          >
            <GeneralActivity currentTenderId={currentTenderId} />
          </Route>
          <Route
            path={[`${ROUTES.adminPageStatistic}/:id/favorites`, `/worthy${ROUTES.adminPageStatistic}/:id/favorites`]}
          >
            <FavoritesActivity currentTenderId={currentTenderId} />
          </Route>
          <Route
            path={[
              `${ROUTES.adminPageStatistic}/:id/viewed-items`,
              `/worthy${ROUTES.adminPageStatistic}/:id/viewed-items`,
            ]}
          >
            <ViewedItemsActivity currentTenderId={currentTenderId} />
          </Route>
          <Route path='*' component={P404} />
        </Switch>
      )}
    </div>
  )
}
